"use client";

import { Toaster } from "sonner";

export function AppToaster() {
  return (
    <Toaster
      richColors
      position="top-right"
      expand
      closeButton
      toastOptions={{
        duration: 5000,
        classNames: {
          toast:
            "rounded-xl border border-border/60 bg-background/95 text-foreground shadow-lg backdrop-blur",
          title: "text-sm font-semibold",
          description: "text-xs text-muted-foreground",
          actionButton:
            "rounded-lg bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground",
          cancelButton:
            "rounded-lg bg-muted px-3 py-1.5 text-xs font-medium text-muted-foreground",
          closeButton:
            "rounded-lg border border-border/60 bg-background/90 text-muted-foreground hover:text-foreground",
        },
      }}
    />
  );
}
